import {
  Button,
  Card,
  Col,
  Form,
  Input,
  message,
  Row,
  Select,
  Spin,
  Tag,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import Post from "../services/Post";
import { LoadingOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const Recharge = () => {
  const [operatorList, setOperatorList] = useState([]);
  const [operatorLoading, setOperatorLoading] = useState(false);
  const [selectedOperator, setSelectedOperator] = useState();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [circle, setCircle] = useState(null);
  const [circleLoading, setCircleLoading] = useState(false);

  const type = "mobile";
  const navigate = useNavigate();

  const getOperatorList = async () => {
    setOperatorLoading(true); // 👈 Start loading
    const res = await Post.PrepaidOperator();
    const data = Array.isArray(res.data) ? res.data : [];
    setOperatorList(data);
    setOperatorLoading(false); // 👈 Stop loading
    return data;
  };

  const handlePhoneNumberChange = async (e) => {
    const value = e.target.value;
    setPhoneNumber(value);

    if (value.length === 10 && /^\d+$/.test(value)) {
      setCircleLoading(true);
      try {
        const res = await Post.HlrCheck({ number: value, type });

        if (res.data.response_code === 1 && res.data.status) {
          const info = res.data.info;
          setCircle(info.circle);

          const operators = await getOperatorList();
          const foundOperator = operators.find((op) =>
            op.name.toLowerCase().includes(info.operator.toLowerCase())
          );

          if (foundOperator) {
            setSelectedOperator(foundOperator);
          } else {
            message.warning(
              `Operator "${info.operator}" not found in the list. Please select manually.`
            );
          }
        } else {
          message.error(
            res.data.message || "Could not fetch operator details."
          );
        }
      } catch (error) {
        console.error(error);
        message.error("Something went wrong while checking number.");
      } finally {
        setCircleLoading(false);
      }
    }
  };

  const handleSelectOperator = (value) => {
    const selected = operatorList.find((op) => op.id === value);
    setSelectedOperator(selected);
  };

  const nextPage = () => {
    if (selectedOperator && circle && phoneNumber) {
      navigate("/user/recharge/plans", {
        state: {
          circle,
          paysprintId: selectedOperator.id,
          phoneNumber,
        },
      });
    } else {
      message.warning("Please complete all required fields.");
    }
  };

  return (
    <div className="layout-content">
      <Row className="form-row">
        <Col xs={24} md={16} lg={12}>
          <Card bordered={false} className="criclebox h-full">
            <Typography.Title level={5}>Enter Phone Number</Typography.Title>
            <Input
              size="large"
              placeholder="Enter 10-digit number"
              maxLength={10}
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              addonAfter={
                circle ? (
                  <Tag color="green">{circle}</Tag>
                ) : (
                  circleLoading && <Spin indicator={<LoadingOutlined spin />} />
                )
              }
              onKeyDown={(e) => {
                const { key, ctrlKey, metaKey } = e.nativeEvent;
                if ((ctrlKey || metaKey) && key.toLowerCase() === "v") return;
                if (!/^\d$/.test(key) && key !== "Backspace")
                  e.preventDefault();
              }}
              onPaste={(e) => {
                const pasteData = e.clipboardData.getData("text");
                if (!/^\d+$/.test(pasteData)) e.preventDefault();
              }}
            />
          </Card>
        </Col>
      </Row>

      {circle && (
        <Row className="form-row">
          <Col xs={24} md={16} lg={12}>
            <Card bordered={false} className="criclebox h-full">
              <Typography.Title level={5}>Select Operator</Typography.Title>
              <Select
                showSearch
                placeholder="Select an Operator"
                value={selectedOperator?.id}
                onChange={handleSelectOperator}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                className="operator-select mb-4"
                size="large"
                loading={operatorLoading || circleLoading} // 👈 Show loading spinner
                options={operatorList.map((op) => ({
                  value: op.id,
                  label: op.name,
                }))}
              />
              <Button
                className="form-btn"
                onClick={nextPage}
                disabled={circleLoading || !selectedOperator}
                loading={circleLoading}
              >
                Proceed
              </Button>
            </Card>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default Recharge;
